import { LANGUAGE_EN } from "@/pages/dashboard/_config/constant";

export const getTranslatedText = (
  textEn: React.ReactNode,
  textCn: React.ReactNode,
  locale: string,
): React.ReactNode => {
  const title = locale === LANGUAGE_EN ? textEn || textCn : textCn || textEn;

  return title;
};